/**
 * @name Citations Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/citations`;

export const deleteCitation = (citationId: number) => `${base}/${citationId}/`;

